import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { UiModel } from './ui.models';
import { UiStore } from './ui.store';

@Injectable({ providedIn: 'root' })
export class UiQuery extends Query<UiModel> {
  protected _uiStore: UiStore;

  constructor() {
    const _uiStore = inject(UiStore);

    super(_uiStore);

    this._uiStore = _uiStore;
  }
}
